export enum OriginsEnum {
  OVERALL = '1',
  NO_RESULTS = '2',
  LOW_RESULTS = '3',
}
